<template>
  <div class="">
    <div  style="max-height: 165px;overflow: hidden;" class="relative" :style="mainStyle">
      <div v-if="data.type=='text'" class="p-3" :style="textStyle" style="min-height: 50px;border-bottom: 1px solid #E7E9EB;">
        <span style="font-family: inherit;">
          {{data.text}}
        </span>
      </div>
      <div v-if="data.type=='image'" style="height: 110px;">
        <img v-if="!data.image" src="@/assets/img/header-img-h5.png" alt="" width="100%" height="100%" style="height: 110px"/>
        <div v-else-if="data.image=='none'" style="height: 110px"></div>
        <img v-else :src="data.image!='none'?convertDownloadUrl(data.image):''" alt="" width="100%" height="100%" style="height: 110px"/>
      </div>
      <div v-if="data.type=='carousel'" style="min-height: 110px" :class="{'carousel-out':data.carouselType == 'out'}">
        <!-- <el-carousel height="110px" v-if="data.carouselImageList" :indicator-position="indicatorPosition">
          <el-carousel-item v-for="item in data.carouselImageList" :key="item.url">
            <img :src="convertDownloadUrl(item.url)" alt="" width="100%" />
          </el-carousel-item>
        </el-carousel> -->
        <van-swipe
          v-if="data.carouselImageList"
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item v-for="item in data.carouselImageList" :key="item.url">
            <img :src="convertDownloadUrl(item.url)" alt="" width="100%" style="height: 110px"/>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DisplayHeader',
  components: { },
  props: {
    themeHeader: {
      type: Object,
      default: ()=>({})
    },
  },
  computed: {
    textStyle() {
      return {
        color: this.data.textColor,
        fontFamily: this.data.textFamily,
        fontWeight: this.data.textWeight?600:400,
        fontSize: this.data.textSize,
        lineHeight: '30px',
        boxSizing: 'border-box'
      }
    },
    mainStyle() {
      return {
        textAlign: this.data.align,
        backgroundColor: this.data.backgroundColor
      }
    }
  },
  created() {
    //console.log('66666',this.themeHeader)
    if(this.themeHeader?.type) {
      this.data = this.themeHeader
      if(this.data.carouselType == 'in') {
        this.indicatorPosition = null
        this.indicatorToBack()
      } else if(this.data.carouselType == 'out'){
        this.indicatorPosition = 'outside'
        this.$nextTick(()=>{
          this.indicatorToimage()
        })
      }
    }
  },
  data() {
    return {
      indicatorPosition: null,
      data: {
        show: true,
        backgroundColor: '#ffffff',
        type: 'image',
        align: '2',
        text: '',
        textColor: "#333333",
        textFamily: 'inherit',
        textSize: '14px',
        textWeight: false,
        carouselType: 'in',
        carouselImageList: [
          {
            url: '',
            fileName: ''
          }
        ],
      },
    }
  },
  methods: {
    convertDownloadUrl(url) {
      return window.location.origin + '/fill/api/v1/download?fileName=' + url
    },
    // 将轮播图指示器渲染成图片
    indicatorToimage() {
      let a = document.querySelectorAll(".van-swipe__indicator")
      console.log('a', a)
      //console.log('carouselImageList', this.data.carouselImageList)
      if(a.length>0) {
        for (let i in this.data.carouselImageList){

          let img0 = a[i].querySelector("img")
          if(img0) {
            a[i].removeChild(img0)
          }

          //添加一个img
          let img = document.createElement('img')
          img.src = this.convertDownloadUrl(this.data.carouselImageList[i].url)
          img.width = 56
          img.height = 31
          //加到button里面
          a[i].appendChild(img)
        }

      }

    },
    indicatorToBack() {
      let a = document.querySelectorAll(".van-swipe__indicator")
      if(a.length>0) {
        for (let i in this.data.carouselImageList){
          let img0 = a[i].querySelector("img")
          a[i].removeChild(img0)
        }
      }
    }
  },
  watch: {
    themeHeader: {
      handler(v) {
        //console.log('555556667779999900000', this.themeHeader)
        if(this.themeHeader?.type) {
          this.data = this.themeHeader
          if(this.data.carouselType == 'in') {
            this.indicatorPosition = null
            this.indicatorToBack()
          } else if(this.data.carouselType == 'out'){
            this.indicatorPosition = 'outside'
            this.$nextTick(()=>{
              this.indicatorToimage()
            })
          }
        }
      },
      deep: true
    },
  },
}
</script>

<style lang="scss" scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 30px;
  line-height: 110px;
  text-align: center;
  //background-color: #F5F5F5;
}
.my-swipe.van-swipe {
  height: 110px;
}
.carousel-out {
  .my-swipe.van-swipe {
    height: 165px;
  }
  ::v-deep .van-swipe__indicator {
    width: 56px;
    height: 31px;
    img {
      width: 56px;
      height: 31px;
      border-radius: 4px;
    }
  }

}
</style>



